var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('div', {
    staticClass: "loading"
  }), _c('div', {
    staticClass: "loading-overlay"
  })]) : _vm._e(), _vm.image ? _c('img', {
    staticClass: "w-100",
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.getTitle))]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getFormTitle)
    }
  }), _c('div', {
    staticClass: "form"
  }, _vm._l(_vm.bindFields, function (field, key) {
    var _vm$v$$bindFieldsInpu;
    return _c('div', {
      key: key,
      staticClass: "form-group"
    }, [field.type === 'mobile_phone' ? _c('div', [_c('label', {
      staticClass: "field__label"
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.bindFieldsInput[field.matched_key],
        expression: "bindFieldsInput[field.matched_key]"
      }],
      staticClass: "field__input",
      attrs: {
        "type": "tel",
        "placeholder": field.placeholder,
        "disabled": _vm.fetchError,
        "maxlength": "10"
      },
      domProps: {
        "value": _vm.bindFieldsInput[field.matched_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.bindFieldsInput, field.matched_key, $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.bindFieldsInput.mobile_phone.$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.getValidateText(field)) + " ")]) : _vm._e()]) : field.type === 'TWIDNumber' ? _c('div', [_c('label', {
      staticClass: "field__label"
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.bindFieldsInput[field.matched_key],
        expression: "bindFieldsInput[field.matched_key]"
      }],
      staticClass: "field__input",
      attrs: {
        "type": "text",
        "placeholder": field.placeholder,
        "disabled": _vm.fetchError,
        "maxlength": "10"
      },
      domProps: {
        "value": _vm.bindFieldsInput[field.matched_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.bindFieldsInput, field.matched_key, $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.bindFieldsInput.TWIDNumber.$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.getValidateText(field)) + " ")]) : _vm._e()]) : _c('div', [_c('label', {
      staticClass: "field__label"
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.bindFieldsInput[field.matched_key],
        expression: "bindFieldsInput[field.matched_key]"
      }],
      staticClass: "field__input",
      attrs: {
        "type": "text",
        "placeholder": field.placeholder,
        "disabled": _vm.fetchError
      },
      domProps: {
        "value": _vm.bindFieldsInput[field.matched_key]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.bindFieldsInput, field.matched_key, $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), (_vm$v$$bindFieldsInpu = _vm.v$.bindFieldsInput[field.matched_key]) !== null && _vm$v$$bindFieldsInpu !== void 0 && _vm$v$$bindFieldsInpu.$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.getValidateText(field)) + " ")]) : _vm._e()])]);
  }), 0)]), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(_vm._s(_vm.getExitActionText))]), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.checkSubmit
    }
  }, [_vm._v(_vm._s(_vm.getSubmitActionText))])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }